import { useSearchParams } from 'next/navigation';

import type { FilteredPackage } from '@/infra/types/voyageInfo/package';

import { selectAccessKey } from '@/ducks/accessKeys';
import { selectQuickFindLinkById } from '@/ducks/common/lookup/selectors';
import useFlowType from '@/features/flowType/useFlowType';
import { useAppSelector } from '@/store';

import AKTrueZeroResults from './AKTrueZeroResults';
import DefaultZeroResults from './DefaultZeroResults';
import MNVVTrueZeroResults from './MNVVTrueZeroResults';
import QFTrueZeroResults from './QFTrueZeroResults';

import './ZeroResults.scss';

const ZeroResults = ({ renderPackage }: { renderPackage: (e: FilteredPackage) => React.ReactNode }) => {
  const hasAccessKey = !!useAppSelector(selectAccessKey);
  const { isMNVV } = useFlowType();
  const searchParams = useSearchParams();
  const quickFindId = searchParams.get('quickFindID');
  const isQuickFind = !!useAppSelector((state) => selectQuickFindLinkById(state, quickFindId));

  const showAK = hasAccessKey;
  const showMNVV = !hasAccessKey && isMNVV;
  const showQF = !hasAccessKey && !isMNVV && isQuickFind;
  const showDefault = !hasAccessKey && !isMNVV && !isQuickFind;

  return (
    <section className="ZeroResults">
      {showAK && <AKTrueZeroResults />}
      {showMNVV && <MNVVTrueZeroResults />}
      {showQF && <QFTrueZeroResults />}
      {showDefault && <DefaultZeroResults renderPackage={renderPackage} />}
    </section>
  );
};

export default ZeroResults;
